(function cascadiaCart(){

  // ───────── config ─────────
  const SEL = {
    checkoutBtn:  'button[name="checkout"], .cart__checkout-button, a[href="/checkout"]',
    lineDiscount: '[class*="discount"]'
  };
  const FALLBACK = { currency:'CAD', tiers:[{ label:'Free soap sample', type:'soap_sample', threshold:40, cap:1 }] };
  const CFG = window.cascadiaConfig || FALLBACK;
  const $  = (s, r=document) => r.querySelector(s);
  const $body = () =>
    document.querySelector('#CartPageForm') ||
    document.querySelector('.drawer__inner, .cart-drawer__content, [data-cart-drawer] .drawer__cart');

  // ───────── price display ─────────
  const currency       = CFG.currency || 'CAD';
  const currencySymbol = { CAD:'$', USD:'$', GBP:'£', EUR:'€', AUD:'$', NZD:'$', CNY:'¥', JPY:'¥' }[currency] || '$';
  const moneyFormat    = c => currency === 'JPY' ? currencySymbol + Math.round(c) : currencySymbol + (c / 100).toFixed(2);
  const money          = c => c === 0 ? 'Free' : moneyFormat(c) + '\u00a0' + currency;

  // show the scent metaobject's name for Scent options; falls back to the raw value
  const _scentNameFetched = new Set(); // handles already looked up this session
  const scentNameFor = (item, o) => {
    if(!/scent/i.test(o.name)) return o.value;
    const map = window.cascadiaScentNamesByVariant || {};
    return map[item.variant_id] || o.value;
  };

  // ───────── soap threshold ─────────
  const soapThreshold = () => {
    const t = (CFG.tiers||[]).find(t => /soap/i.test((t.type||'') + (t.label||'')));
    return t ? t.threshold : 40;
  };

  // ───────── render guard — prevents our DOM mutations from re-triggering renders ─────────
  let _rendering = false;

  // ───────── render cycle ─────────
  async function render(){
    if(_rendering) return;
    _rendering = true;

    let cart;
    try { cart = await window.cascadiaState.getState(); } catch(e){ _rendering = false; return; }
    const body = $body();
    if(!body){ _rendering = false; return; }
    cart = await enforceSampleThreshold(cart);

    // Motion needs a beat to add/remove its is-empty class — only wait when
    // we're actually near that boundary (0 or 1 items), not on every render
    if(cart.itemCount <= 1){
      await new Promise(resolve => setTimeout(resolve, 50));
    }

    const cartDrawer = document.querySelector('#CartDrawer');
const emptyState = cart.itemCount === 0;

    let emptyLabel = null;
    if(emptyState){
      const sorted = [...(CFG.tiers || [])].sort((a,b) => a.threshold - b.threshold);
      const firstTier = sorted[0];
      if(firstTier){
        emptyLabel = firstTier.copyEmpty && firstTier.copyEmpty.trim()
          ? firstTier.copyEmpty
              .replace('{threshold}', firstTier.threshold)
              .replace('{label}', firstTier.label.toLowerCase())
          : `Unlock your free ${firstTier.label.toLowerCase()} at <b>$${firstTier.threshold}</b>`;
      }
    }

    if(!emptyState){
      renderLadder(cart, body);
      addTrust(body);
    } else {
      const oldLadder = document.querySelector('#cascadia-ladder');
      if(oldLadder) oldLadder.remove();
      const oldTrust = document.querySelector('#cascadia-trust');
      if(oldTrust) oldTrust.remove();
    }

    cleanSavings(cart);
    styleDrawerShell();
    if(window.cascadiaFooter) window.cascadiaFooter.render(cart);
    updateCartBadge(cart);
    renderEmptyCart(body, emptyLabel, cart.itemCount === 0);
    renderEmptyCartPage();
    await renderLineItems(cart, body);
    if(cart.itemCount > 0) await renderUpsell(cart, body);

    const drawerEl = document.querySelector('#CartDrawer');
    if(drawerEl) drawerEl.dataset.casReady = '1';

    _rendering = false;
  }

  // ───────── ladder primitive ─────────
  function evaluateLadder(total, tiers){
    const sorted = [...tiers].sort((a,b) => a.threshold - b.threshold);
    if(!sorted.length) return null;
    const next = sorted.find(t => total < t.threshold * 100);
    const allMet = !next;
    const maxThreshold = sorted[sorted.length-1].threshold * 100;
    let label;
    if(allMet){
      const m = [...sorted].reverse().find(t => t.copyMet && t.copyMet.trim());
      label = m ? m.copyMet : `You've unlocked every reward — nicely done.`;
    } else {
      const away = next.threshold * 100 - total;
      const awayFormatted = currencySymbol + (away / 100).toFixed(2) + '\u00a0' + currency;
      label = next.copyFar && next.copyFar.trim()
        ? next.copyFar.replace('{away}', awayFormatted)
        : `You're <b>${awayFormatted}</b> away from ${next.label.toLowerCase()}.`;
    }
    return { sorted, next, allMet, total, maxThreshold, label };
  }

  function shortLabel(label){
    return label.replace(/^free\s+/i, '').split(' ')[0];
  }

  // ───────── reward stations (ladder) ─────────
  const LADDER_ACCENT = '#1e3a20';
  const LADDER_EARNED = '#c8a24e';      // unlocked circles + progress line
  const LADDER_EARNED_TEXT = '#8a6010'; // "Unlocked" text + check (readable on white)

  function ladderIcon(tier){
    const key = ((tier.type || '') + ' ' + (tier.label || '')).toLowerCase();
    const open = '<svg width="18" height="18" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">';
    if(/soap/.test(key)) return open + '<path d="M10 3l6 3.5v7L10 17l-6-3.5v-7L10 3z"/><path d="M7.5 9.5c.8-1.2 4.2-1.2 5 0"/></svg>';
    if(/ship|deliver/.test(key)) return open + '<path d="M2.5 5.5h9v7.5h-9z"/><path d="M11.5 8h3.2l2.3 2.6V13h-5.5"/><circle cx="6" cy="14" r="1.5"/><circle cx="14.2" cy="14" r="1.5"/></svg>';
    if(/skin|serum|oil|lotion|cream/.test(key)) return open + '<path d="M8 2.5h4v2.5H8z"/><path d="M7 5h6l1 2.5v8.5a1.5 1.5 0 01-1.5 1.5h-5A1.5 1.5 0 016 16V7.5L7 5z"/><path d="M10 10.5c1.2-.9 2-.4 2 .6-1 .1-1.6-.2-2-.6zm0 0v3"/></svg>';
    return open + '<path d="M3.5 8h13v8.5h-13z"/><path d="M2.5 5.5h15V8h-15z"/><path d="M10 5.5v11"/><path d="M10 5.5C9 3 6.5 3 6.5 4.5S9 5.5 10 5.5zm0 0c1-2.5 3.5-2.5 3.5-1S11 5.5 10 5.5z"/></svg>';
  }

  // segments: [{ tier, filled, active, fillPct }] — same shape renderLadder already builds
  function ladderStationsHtml(segments, label){
    const n = segments.length;
    const nextIdx = segments.findIndex(s => !s.filled);

    let lines = '';
    for(let i = 1; i < n; i++){
      const left = ((i - 0.5) / n) * 100;
      const width = (1 / n) * 100;
      const s = segments[i];
      const fill = s.filled ? 100 : (s.active ? s.fillPct : 0);
      lines += `<div style="position:absolute;left:${left}%;width:${width}%;top:19px;height:2px;background:#e8e5e0;"></div>`;
      if(fill > 0) lines += `<div style="position:absolute;left:${left}%;width:${width * fill / 100}%;top:19px;height:2px;background:${LADDER_EARNED};"></div>`;
    }

    const stations = segments.map((s, i) => {
      const earned = s.filled;
      const isNext = i === nextIdx;
      const circle = earned
        ? `background:${LADDER_EARNED};color:#3d2314;border:none;`
        : isNext
          ? `background:#fff;color:${LADDER_ACCENT};border:1.5px solid ${LADDER_ACCENT};`
          : `background:#faf8f5;color:#8a7e6e;border:1.5px solid #d6cdbf;`;
      const badge = earned
        ? `<span style="position:absolute;right:-3px;bottom:-3px;width:16px;height:16px;border-radius:50%;background:#fff;border:1.5px solid ${LADDER_EARNED};box-sizing:border-box;display:flex;align-items:center;justify-content:center;color:${LADDER_EARNED_TEXT};"><svg width="8" height="8" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2.5 6.3l2.4 2.4 4.6-5"/></svg></span>`
        : '';
      const sub = earned
        ? `<span style="font-size:11px;font-weight:500;color:${LADDER_EARNED_TEXT};">Unlocked</span>`
        : `<span style="font-size:11px;color:#6b5c4a;">$${s.tier.threshold}</span>`;
      const strong = earned || isNext;
      return `<div style="display:flex;flex-direction:column;align-items:center;gap:5px;min-width:0;">
          <div style="position:relative;width:30px;height:30px;border-radius:50%;box-sizing:border-box;display:flex;align-items:center;justify-content:center;${circle}">${ladderIcon(s.tier)}${badge}</div>
          <div style="display:flex;flex-direction:column;align-items:center;gap:1px;text-align:center;padding:0 4px;">
            <span style="font-size:12px;font-weight:${strong ? 600 : 500};color:${strong ? '#3d2314' : '#6b5c4a'};line-height:1.25;">${s.tier.label}</span>
            ${sub}
          </div>
        </div>`;
    }).join('');

    return `<style>.cas-ladder-head b{font-family:'Jost',sans-serif;font-style:normal;font-weight:600;font-size:0.85em;color:${LADDER_ACCENT};}</style>
      <div style="padding:10px 0 8px;font-family:'Jost',sans-serif;">
        <p class="cas-ladder-head" style="margin:0 0 10px;text-align:center;font-family:'Cormorant Garamond',Georgia,serif;font-style:italic;font-size:17px;line-height:1.25;color:#3d2314;font-weight:500;">${label}</p>
        <div style="position:relative;">
          ${lines}
          <div style="position:relative;display:grid;grid-template-columns:repeat(${n}, minmax(0, 1fr));">${stations}</div>
        </div>
      </div>`;
  }

  function renderLadder(cart, body, forceLabel){
    const state = evaluateLadder(cart.total, CFG.tiers || []);
    if(!state) return;
    const { sorted, total } = state;
    const label = forceLabel || state.label;
    const isDesktop = !!document.querySelector('#CartPageForm') && window.innerWidth >= 600;

    const segments = sorted.map((tier, i) => {
      const start = i === 0 ? 0 : sorted[i-1].threshold * 100;
      const end = tier.threshold * 100;
      const filled = total >= end;
      const active = !filled && total > start;
      const fillPct = active
        ? Math.max(4, Math.min(100, ((total - start) / (end - start)) * 100))
        : filled ? 100 : 0;
      return { tier, filled, active, fillPct };
    });

    let bar = $('#cascadia-ladder');
if(!bar){
  bar = document.createElement('div');
  bar.id = 'cascadia-ladder';
  // insert after our header if it exists, otherwise prepend
  const header = body.querySelector('#cas-drawer-header');
  if(header){
    header.insertAdjacentElement('afterend', bar);
  } else {
    body.prepend(bar);
  }
}
    // .drawer__scrollable already carries 20px side padding — adding our own
    // here too would double it up and misalign us against the line items.
    // The cart page has no equivalent padding, so it still needs its own 20px.
    const isPage = !!document.querySelector('#CartPageForm');
    bar.style.cssText = `padding:0 ${isPage ? '20px' : '0'} 4px;box-sizing:border-box;width:100%`;

    bar.innerHTML = ladderStationsHtml(segments, label);
    return; // stations replace the old mobile/desktop bars below — that old block can be deleted later

    if(!isDesktop){
      bar.innerHTML = `
        <div style="padding:13px 14px 11px;background:none;border-radius:10px;font-family:'Jost',sans-serif;">
          <p style="font-family:'Cormorant Garamond',Georgia,serif;font-style:italic;font-size:17px;color:#3d2314;margin:0 0 10px;line-height:1.3;font-weight:500;">${label}</p>
          <div style="display:flex;gap:4px;height:4px;border-radius:999px;overflow:hidden;margin-bottom:4px;">
            ${segments.map(s => `
              <div style="flex:1;background:#e8e5e0;position:relative;overflow:hidden;">
                <div style="position:absolute;inset:0;background:#c8a24e;width:${s.fillPct}%;"></div>
              </div>
            `).join('')}
          </div>
          <div style="display:flex;">
            ${segments.map(s => `
              <div style="flex:1;text-align:center;">
                <span style="font-size:12.5px;font-weight:${s.filled || s.active ? '600' : '500'};color:${s.filled ? '#8a6010' : s.active ? '#3d2314' : '#6b5c4a'};white-space:nowrap;">
                  $${s.tier.threshold} · ${shortLabel(s.tier.label)}${s.filled ? ' ✓' : ''}
                </span>
              </div>
            `).join('')}
          </div>
        </div>`;
    } else {
      bar.innerHTML = `
        <div style="padding:0 0 16px;border-bottom:0.5px solid #e8e5e0;font-family:'Jost',sans-serif;margin-bottom:16px;">
          <p style="font-family:'Cormorant Garamond',Georgia,serif;font-style:italic;font-size:20px;color:#3d2314;margin:0 0 14px;line-height:1.3;font-weight:500;">${label}</p>
          <div style="display:flex;gap:6px;">
            ${segments.map(s => `
              <div style="flex:1;min-width:0;">
                <div style="height:3px;border-radius:999px;overflow:hidden;background:#e8e5e0;margin-bottom:5px;">
                  <div style="height:100%;width:${s.fillPct}%;background:#c8a24e;"></div>
                </div>
                <span style="font-size:11px;white-space:nowrap;color:${s.filled ? '#926129ff' : s.active ? '#3d2314' : '#a59a8a'};font-weight:${s.active ? '500' : '400'};">
                  $${s.tier.threshold} · ${shortLabel(s.tier.label)}${s.filled ? ' ✓' : ''}
                </span>
              </div>
            `).join('')}
          </div>
        </div>`;
    }
  }

  // ───────── savings chip ─────────
  function cleanSavings(cart){
    document.querySelectorAll(`${SEL.lineDiscount}[data-cas-done]`).forEach(el => {
      delete el.dataset.casDone;
    });
    document.querySelectorAll(SEL.lineDiscount).forEach(el => {
      if(el.dataset.casDone) return;
      const m = el.textContent.trim().match(/\(\s*-?\$?([\d,.]+)\s*\)/);
      if(!m) return;
      const amount = parseFloat(m[1].replace(',', '.'));
      let title = null;
      if(cart && cart.items){
        cart.items.forEach(item => {
          (item.discounts || []).forEach(d => {
            if(Math.abs((d.amount / 100) - amount) < 0.01) title = d.title;
          });
        });
      }
      let label;
      if(title){
        const humanized = title
          .replace(/([a-z])([A-Z])/g, '$1 $2')
          .replace(/[-_]/g, ' ')
          .replace(/\b(discount|bundle|bogos|deal|volume|soapbundle)\b/gi, '')
          .replace(/\s+/g, ' ')
          .trim();
        label = humanized.length > 0 ? humanized : 'You save';
      } else {
        label = 'You save';
      }
      el.dataset.casDone = '1';
      el.classList.add('cas-chip');
      el.textContent = label;
    });
  }

  // ───────── trust microcopy primitive ─────────
  function addTrust(body){
    body.querySelectorAll('.ajaxcart__note').forEach(el => el.remove());
    // footer handles trust line in drawer — only inject on cart page
    const isDrawer = !document.querySelector('#CartPageForm');
    if(isDrawer) return;
    const btn = body.querySelector(SEL.checkoutBtn);
    if(btn && !body.querySelector('#cascadia-trust')){
      const t = document.createElement('div');
      t.id = 'cascadia-trust';
      t.innerHTML = CFG.trustLine || 'Taxes and any duties shown before you pay';
      const wrapper = btn.closest('.cart__checkout-wrapper') || btn.parentNode;
      wrapper.parentNode.insertBefore(t, wrapper);
    }
  }

  // ───────── sample threshold enforcement ─────────
  let removingSample = false;

  async function enforceSampleThreshold(cart){
  // enforce soap sample threshold
  const sampleLine = cart.sampleLine;
  if(sampleLine && cart.total < soapThreshold() * 100){
    if(removingSample) return cart;
    removingSample = true;
    try {
      await window.cascadiaState.removeFromCart(sampleLine.key);
      const staleLine = document.querySelector(`[data-key="${sampleLine.key}"]`);
      if(staleLine) staleLine.remove();
      cart = await window.cascadiaState.refresh();
    } catch(e){ return cart; }
    finally { removingSample = false; }
  }

  // enforce reward tier thresholds
  const sorted = [...(CFG.tiers||[])].sort((a,b) => a.threshold - b.threshold);
  for(const tier of sorted){
    const rewardLine = cart.rewardLines && cart.rewardLines[tier.type];
    if(!rewardLine) continue;
    if(cart.total < tier.threshold * 100){
      try {
        await window.cascadiaState.removeFromCart(rewardLine.key);
        const staleLine = document.querySelector(`[data-key="${rewardLine.key}"]`);
        if(staleLine) staleLine.remove();
        cart = await window.cascadiaState.refresh();
      } catch(e){ console.warn('[cascadia] reward remove failed', e); }
    }
  }

  return cart;
}

// ───────── discount label formatting (no more regex-guessing from rendered text) ─────────
  function humanizeDiscountTitle(title){
    const cleaned = (title || '')
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/[-_]/g, ' ')
      .replace(/\b(discount|bundle|bogos|deal|volume|soapbundle)\b/gi, '')
      .replace(/\s+/g, ' ')
      .trim();
    return cleaned.length > 0 ? cleaned : 'You save';
  }

  // ───────── upsell strip — seeded from the highest-value cart line ─────────
  var _upsellCache = { seedId: null, products: null };

  function pickSeedProduct(cart){
    if(!cart.items.length) return null;
    var sorted = [...cart.items].sort((a,b) => {
      var aTotal = a.line_price != null ? a.line_price : a.price * a.quantity;
      var bTotal = b.line_price != null ? b.line_price : b.price * b.quantity;
      return bTotal - aTotal;
    });
    return sorted[0];
  }

  var _routineCache = new Map(); // handle -> routine product handles

  async function getRoutineHandles(handle){
    if(_routineCache.has(handle)) return _routineCache.get(handle);
    try {
      var res = await fetch(`/products/${handle}?view=routine-json`);
      var data = await res.json();
      var handles = (data.routineProducts || []).map(p => p.handle);
      _routineCache.set(handle, handles);
      return handles;
    } catch(e){
      _routineCache.set(handle, []);
      return [];
    }
  }

  async function getUpsellProducts(cart){
    var seed = pickSeedProduct(cart);
    if(!seed) return [];

    var cacheKey = seed.product_id;
    if(_upsellCache.seedId === cacheKey && _upsellCache.products){
      return filterOutCartItems(_upsellCache.products, cart);
    }

    var routineHandles = await getRoutineHandles(seed.handle);
    var routineProducts = [];
    if(routineHandles.length){
      var fetched = await Promise.all(routineHandles.map(h =>
        fetch(`/products/${h}.js`).then(r => r.json()).catch(() => null)
      ));
      routineProducts = fetched.filter(p => p && p.available);
    }

    var fallbackProducts = [];
    try {
      var res = await fetch(`/recommendations/products.json?product_id=${seed.product_id}&limit=6&intent=related`);
      var data = await res.json();
      fallbackProducts = (data.products || []).filter(p => p.available);
    } catch(e){
      console.warn('[cascadia] upsell fallback fetch failed', e);
    }

    // Routine products first, then fill remaining slots with recommendations,
    // deduping by handle so nothing shows twice
    var seenHandles = new Set(routineProducts.map(p => p.handle));
    var combined = routineProducts.concat(
      fallbackProducts.filter(p => !seenHandles.has(p.handle))
    );

    _upsellCache = { seedId: cacheKey, products: combined };
    return filterOutCartItems(combined, cart);
  }

  function filterOutCartItems(products, cart){
    var cartHandles = new Set(cart.items.map(i => i.handle));
    return products.filter(p => !cartHandles.has(p.handle)).slice(0, 3);
  }

  async function renderUpsell(cart, body){
    var lineItemsContainer = body.querySelector('[data-products], .cart__items');
    if(!lineItemsContainer) return;

    var existing = document.getElementById('cascadia-upsell');
    if(existing) existing.remove();

    var products = await getUpsellProducts(cart);
    if(!products.length) return;

    var isPage = !!document.querySelector('#CartPageForm');
    var wrap = document.createElement('div');
    wrap.id = 'cascadia-upsell';
    wrap.style.cssText = `margin:10px ${isPage ? '20px' : '0'} 4px; padding-top:10px; border-top:0.5px solid #e3d9c2;`;

    var title = document.createElement('p');
    title.style.cssText = "font-size:12px; font-weight:600; letter-spacing:0.02em; color:#3d2314; margin:0 0 8px;";
    title.textContent = 'Complete your routine';
    wrap.appendChild(title);

    var strip = document.createElement('div');
    strip.className = 'cas-upsell-strip';
    strip.style.cssText = 'display:flex; gap:6px; overflow-x:auto; -webkit-overflow-scrolling:touch; scrollbar-width:none; padding-bottom:2px;';

    products.forEach(p => {
      var variant = p.variants[0];
      var card = document.createElement('div');
      card.className = 'cas-upsell-card';
      card.dataset.variantId = variant.id;
      card.style.cssText = 'flex:0 0 168px; display:flex; align-items:center; gap:8px; border:1px dashed #50390fff; border-radius:10px; padding:6px; background:transparent; box-sizing:border-box;';
      card.innerHTML = `
        <a href="${p.url}" style="display:block; width:40px; height:40px; border-radius:7px; overflow:hidden; background:#f0ece7; flex-shrink:0;">
          <img src="${p.featured_image || ''}" alt="${p.title}" style="width:100%; height:100%; object-fit:cover; display:block;">
        </a>
        <div style="flex:1; min-width:0;">
          <a href="${p.url}" style="display:block; font-size:11px; font-weight:500; color:#3d2314; margin:0 0 2px; line-height:1.25; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; text-decoration:none;">${p.title}</a>
          <span style="font-size:11px; font-weight:600; color:#03593A;">${moneyFormat(variant.price)}</span>
        </div>
        <button type="button" class="cas-upsell-add" aria-label="Add ${p.title.replace(/"/g,'&quot;')} to cart" style="width:24px; height:24px; border-radius:50%; background:#03593A; border:none; color:#fff; font-size:15px; line-height:1; cursor:pointer; display:flex; align-items:center; justify-content:center; flex-shrink:0;">+</button>
      `;
      strip.appendChild(card);
    });

    wrap.appendChild(strip);
    lineItemsContainer.insertAdjacentElement('afterend', wrap);

    if(!strip.dataset.casWired){
      strip.dataset.casWired = '1';
      strip.addEventListener('click', async (e) => {
        var btn = e.target.closest('.cas-upsell-add');
        if(!btn) return;
        var card = btn.closest('.cas-upsell-card');
        var variantId = parseInt(card.dataset.variantId, 10);

        btn.disabled = true;
        var originalHTML = btn.innerHTML;
        btn.innerHTML = '&#10003;';

        try {
          await window.cascadiaState.addToCart(variantId, 1);
          document.dispatchEvent(new CustomEvent('cascadia:cart-changed'));
        } catch(err){
          console.warn('[cascadia] upsell add failed', err);
          btn.innerHTML = originalHTML;
          btn.disabled = false;
        }
      });
    }
  }
  function groupCartItems(items, orderLevelTitles){
    const groups = [];
    const byBundleId = {};
    items.forEach(item => {
      const bundleId = item.properties && item.properties._bundle_id;
      if(bundleId){
        let group = byBundleId[bundleId];
        if(!group){
          group = { type:'bundle', bundleId, fallbackLabel: item.properties._bundle_label || 'Bundle', items: [] };
          byBundleId[bundleId] = group;
          groups.push(group);
        }
        group.items.push(item);
      } else {
        groups.push({ type:'single', item });
      }
    });

    // relabel from the live PRODUCT-LEVEL discount Shopify actually applied
    // (e.g. "Manuka Two Pack"), never from a cart-wide code or sitewide sale —
    // those get filtered out via orderLevelTitles before we even look.
    // dissolve the group entirely if no genuine pack discount remains.
    const resolved = [];
    groups.forEach(g => {
      if(g.type !== 'bundle'){ resolved.push(g); return; }
      const packDiscounts = [];
      g.items.forEach(it => {
        (it.discounts || []).forEach(d => {
          if(!orderLevelTitles.has(d.title)) packDiscounts.push(d.title);
        });
      });
      if(packDiscounts.length === 0){
        g.items.forEach(item => resolved.push({ type:'single', item }));
        return;
      }
      const titleCounts = {};
      packDiscounts.forEach(title => { titleCounts[title] = (titleCounts[title] || 0) + 1; });
      const bestTitle = Object.keys(titleCounts).sort((a, b) => titleCounts[b] - titleCounts[a])[0];
      g.label = humanizeDiscountTitle(bestTitle) || g.fallbackLabel;
      resolved.push(g);
    });

    return resolved;
  }

  function singleItemMarkup(item, rewardKeys, thumbSize, cardPadding, orderLevelTitles){
    const isReward = rewardKeys.includes(item.key);

    const variantText = (item.options_with_values || [])
      .filter(o => o.value && !/default/i.test(o.value))
      .map(o => `${o.name}: ${scentNameFor(item, o)}`)
      .join(' · ');

    const lineTotal = item.line_price != null ? item.line_price : (item.price * item.quantity);

    const product = _compareAtCache.get(item.handle);
    const variant = product && product.variants && product.variants.find(v => v.id === item.variant_id);
    const hasCompareAt = variant && variant.compare_at_price && variant.compare_at_price > item.price;
    const compareAtTotal = hasCompareAt ? variant.compare_at_price * item.quantity : 0;
    const originalLine = item.original_line_price != null ? item.original_line_price : item.price * item.quantity;
    // strike the highest "was" price: compare-at OR the pre-discount price Shopify reports
    const compareTotal = Math.max(compareAtTotal, originalLine);
    const hasStrike = compareTotal > lineTotal;

    const priceHtml = hasStrike
      ? `<span style="font-family:Jost,sans-serif;font-size:13px;color:#a59a8a;text-decoration:line-through;">${moneyFormat(compareTotal)}</span>
         <span style="font-family:Jost,sans-serif;font-size:15px;font-weight:600;color:#03593A;">${moneyFormat(lineTotal)}</span>`
      : `<span style="font-family:Jost,sans-serif;font-size:15px;font-weight:600;color:#03593A;">${moneyFormat(lineTotal)}</span>`;

    const discounts = (item.discounts || []).filter(d => !orderLevelTitles.has(d.title));
    const chipHtml = discounts.length
      ? `<span class="cas-chip" style="display:inline-flex;align-items:center;background:#fbeee6;border:0.5px solid #e6c3ac;border-radius:999px;padding:2px 8px;font-family:Jost,sans-serif;font-size:10px;font-weight:500;color:#B5502C;white-space:nowrap;margin-left:8px;">${humanizeDiscountTitle(discounts[0].title)}</span>`
      : '';

    const qtyHtml = isReward ? '' : `
      <div class="cas-qty-stepper" data-key="${item.key}" style="display:inline-flex;align-items:center;align-self:flex-start;width:fit-content;border:1px solid #3d2314;border-radius:999px;overflow:hidden;margin-top:8px;">
        <button type="button" class="cas-qty-minus" aria-label="Decrease quantity" style="width:32px;height:28px;background:none;border:none;color:#3d2314;font-size:18px;cursor:pointer;">−</button>
        <input type="number" class="cas-qty-input" inputmode="numeric" min="0" step="1" value="${item.quantity}" data-key="${item.key}" aria-label="Quantity for ${item.product_title}" style="width:34px;height:28px;box-sizing:border-box;padding:0;margin:0;text-align:center;background:none;border:none;border-left:1px solid #3d2314;border-right:1px solid #3d2314;border-radius:0;font-family:Jost,sans-serif;color:#3d2314;">
        <button type="button" class="cas-qty-plus" aria-label="Increase quantity" style="width:32px;height:28px;background:none;border:none;color:#3d2314;font-size:18px;cursor:pointer;">+</button>
      </div>`;

    return `
      <div class="cas-line-item" data-key="${item.key}" style="display:grid;grid-template-columns:${thumbSize} 1fr;gap:0 12px;align-items:start;width:100%;border:1px solid #e3d9c2;border-radius:14px;padding:${cardPadding};margin-bottom:6px;box-sizing:border-box;position:relative;">
        <div style="width:${thumbSize};height:${thumbSize};border-radius:10px;overflow:hidden;flex-shrink:0;">
          <img src="${item.image || ''}" alt="${item.product_title}" style="width:100%;height:100%;object-fit:cover;display:block;">
        </div>
        <div style="display:flex;flex-direction:column;gap:3px;min-width:0;padding-right:32px;">
          <a href="${item.url}" style="font-family:Jost,sans-serif;font-size:13px;font-weight:500;color:#3d2314;text-decoration:none;line-height:1.3;">${item.product_title}</a>
          ${variantText ? `<p style="font-family:Jost,sans-serif;font-size:11.5px;color:#6b5c4a;margin:0;line-height:1.3;">${variantText}</p>` : ''}
          <div style="display:flex;align-items:baseline;gap:6px;flex-wrap:wrap;margin-top:4px;">
            ${priceHtml}${chipHtml}
          </div>
          ${qtyHtml}
        </div>
        <div class="cas-line-actions" style="position:absolute;top:10px;right:8px;display:flex;align-items:center;gap:6px;">
          ${isReward || item.product_has_only_default_variant || !item.variant_title || item.variant_title === 'Default Title' ? '' : `
          <button type="button" class="cas-edit-btn" data-key="${item.key}" aria-label="Edit item" style="display:flex;align-items:center;gap:5px;background:none;border:1px solid #b8ab9a;border-radius:8px;padding:5px 9px;cursor:pointer;color:#3d2314;font-family:Jost,sans-serif;font-size:11px;font-weight:500;">
            <svg viewBox="0 0 20 20" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M13.5 3.5l3 3L6 17l-4 1 1-4L13.5 3.5z"/></svg>
            <span class="cas-edit-label">Edit</span>
          </button>`}
          <button type="button" class="cas-remove-btn" data-key="${item.key}" aria-label="Remove item" style="width:30px;height:30px;background:none;border:none;cursor:pointer;color:#3d2314;display:flex;align-items:center;justify-content:center;flex-shrink:0;padding:0;">
            <svg viewBox="0 0 20 20" width="19" height="19" fill="currentColor"><path d="M7 2a1 1 0 00-1 1v1H3a1 1 0 000 2h.5l.7 10.2A2 2 0 006.2 18h7.6a2 2 0 002-1.8L16.5 6h.5a1 1 0 000-2h-3V3a1 1 0 00-1-1H7zm1 2V3h4v1H8zm-1.3 2h8.6l-.7 10H6.4l-.7-10z"/></svg>
          </button>
        </div>
      </div>`;
  }

  function bundleGroupMarkup(group, isMobile){
    const subThumb = isMobile ? '48px' : '56px';
    const totalQty = group.items.reduce((s, it) => s + it.quantity, 0);
    const lineTotal = group.items.reduce((s, it) => s + (it.line_price != null ? it.line_price : it.price * it.quantity), 0);
    const totalDiscount = group.items.reduce((s, it) => s + (it.discounts || []).reduce((ds, d) => ds + (d.amount || 0), 0), 0);
    const originalTotal = lineTotal + totalDiscount;

    const priceHtml = totalDiscount > 0
      ? `<span style="font-family:Jost,sans-serif;font-size:13px;color:#a59a8a;text-decoration:line-through;">${moneyFormat(originalTotal)}</span>
         <span style="font-family:Jost,sans-serif;font-size:16px;font-weight:600;color:#03593A;margin-left:6px;">${moneyFormat(lineTotal)}</span>`
      : `<span style="font-family:Jost,sans-serif;font-size:16px;font-weight:600;color:#03593A;">${moneyFormat(lineTotal)}</span>`;

    const badgeHtml = totalDiscount > 0
      ? `<span class="cas-chip" style="display:inline-flex;align-items:center;background:#fbeee6;border:0.5px solid #e6c3ac;border-radius:999px;padding:3px 10px;font-family:Jost,sans-serif;font-size:11px;font-weight:500;color:#B5502C;white-space:nowrap;">Save ${moneyFormat(totalDiscount)}</span>`
      : '';

    const subRows = group.items.map(item => {
      const variantText = (item.options_with_values || [])
        .filter(o => o.value && !/default/i.test(o.value))
        .map(o => scentNameFor(item, o))
        .join(' · ');
      const unitLine = item.line_price != null ? item.line_price : (item.price * item.quantity);

      return `
        <div class="cas-bundle-sub" data-key="${item.key}" style="display:flex;align-items:center;gap:10px;padding:9px 0;border-top:0.5px solid #ece6db;">
          <div style="width:${subThumb};height:${subThumb};border-radius:8px;overflow:hidden;flex-shrink:0;">
            <img src="${item.image || ''}" alt="${item.product_title}" style="width:100%;height:100%;object-fit:cover;display:block;">
          </div>
          <div style="flex:1;min-width:0;">
            <p style="font-family:Jost,sans-serif;font-size:12px;color:#3d2314;margin:0 0 2px;line-height:1.3;">${variantText || item.product_title}</p>
            <p style="font-family:Jost,sans-serif;font-size:11px;color:#8a7e6e;margin:0;">${moneyFormat(unitLine)}</p>
          </div>
          <div class="cas-qty-stepper" data-key="${item.key}" style="display:inline-flex;align-items:center;width:fit-content;border:1px solid #3d2314;border-radius:999px;overflow:hidden;flex-shrink:0;">
            <button type="button" class="cas-qty-minus" aria-label="Decrease quantity" style="width:26px;height:24px;background:none;border:none;color:#3d2314;font-size:15px;cursor:pointer;">−</button>
            <input type="number" class="cas-qty-input" inputmode="numeric" min="0" step="1" value="${item.quantity}" data-key="${item.key}" aria-label="Quantity for ${item.product_title}" style="width:30px;height:24px;box-sizing:border-box;padding:0;margin:0;text-align:center;background:none;border:none;border-left:1px solid #3d2314;border-right:1px solid #3d2314;border-radius:0;font-family:Jost,sans-serif;color:#3d2314;">            <button type="button" class="cas-qty-plus" aria-label="Increase quantity" style="width:26px;height:24px;background:none;border:none;color:#3d2314;font-size:15px;cursor:pointer;">+</button>
          </div>
          <button type="button" class="cas-remove-btn" data-key="${item.key}" aria-label="Remove item" style="width:28px;height:28px;background:none;border:none;cursor:pointer;color:#3d2314;display:flex;align-items:center;justify-content:center;flex-shrink:0;padding:0;">
            <svg viewBox="0 0 20 20" width="17" height="17" fill="currentColor"><path d="M7 2a1 1 0 00-1 1v1H3a1 1 0 000 2h.5l.7 10.2A2 2 0 006.2 18h7.6a2 2 0 002-1.8L16.5 6h.5a1 1 0 000-2h-3V3a1 1 0 00-1-1H7zm1 2V3h4v1H8zm-1.3 2h8.6l-.7 10H6.4l-.7-10z"/></svg>
          </button>
        </div>`;
    }).join('');

    return `
      <div class="cas-bundle-card" data-bundle-id="${group.bundleId}" style="border:1px solid #e3d9c2;border-radius:14px;padding:14px 14px 4px;margin-bottom:6px;box-sizing:border-box;">
        <div style="display:flex;align-items:baseline;justify-content:space-between;gap:8px;flex-wrap:wrap;">
          <span style="font-family:'Cormorant Garamond',Georgia,serif;font-style:italic;font-size:15px;color:#3d2314;">${group.label} <span style="font-family:Jost,sans-serif;font-style:normal;font-size:11px;color:#8a7e6e;">(${totalQty})</span></span>
          ${badgeHtml}
        </div>
        <div style="margin-top:4px;">${priceHtml}</div>
        <div>${subRows}</div>
      </div>`;
  }

  // ───────── fully self-rendered line items — no Motion DOM scraping ─────────
  async function renderLineItems(cart, body){
    const container = body.querySelector('[data-products], .cart__items');
    if(!container) return;

    const drawerWidth = document.querySelector('#CartDrawer')?.offsetWidth || window.innerWidth;
    const isMobile = drawerWidth < 480;
    const thumbSize = isMobile ? '72px' : '96px';
    const cardPadding = isMobile ? '12px 12px 12px' : '16px 16px 12px';

    const rewardKeys = [
      cart.sampleLine && cart.sampleLine.key,
      ...(cart.rewardLines ? Object.values(cart.rewardLines).map(l => l.key) : [])
    ].filter(Boolean);

    const handles = [...new Set(cart.items.map(i => i.handle))];
    const uncachedHandles = handles.filter(h => !_compareAtCache.has(h));

    const orderLevelApps = (cart.raw && cart.raw.cart_level_discount_applications) || [];
    const orderLevelTitles = new Set(orderLevelApps.map(a => a.title));
    const groups = groupCartItems(cart.items, orderLevelTitles);

    const itemsHtml = groups.map(g => {
      return g.type === 'bundle'
        ? bundleGroupMarkup(g, isMobile)
        : singleItemMarkup(g.item, rewardKeys, thumbSize, cardPadding, orderLevelTitles);
    }).join('');

    const n = cart.itemCount;
    container.innerHTML = groups.length ? `
      <div class="cas-cart-box">
        <div class="cas-cart-box__head">
          <span class="cas-cart-box__title">
            <svg width="15" height="15" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 5h10l-1 9H4L3 5z"/><path d="M6 5V4a2 2 0 014 0v1"/></svg>
            In your cart
          </span>
          <span class="cas-cart-box__count">${n} item${n === 1 ? '' : 's'}</span>
        </div>
        ${itemsHtml}
      </div>` : '';

    if(!container.dataset.casWired){
      container.dataset.casWired = '1';
      container.addEventListener('click', async (e) => {
        const minusBtn = e.target.closest('.cas-qty-minus');
        const plusBtn = e.target.closest('.cas-qty-plus');
        const removeBtn = e.target.closest('.cas-remove-btn');

        if(removeBtn){
          const key = removeBtn.dataset.key;
          removeBtn.disabled = true;
          try {
            await window.cascadiaState.removeFromCart(key);
            document.dispatchEvent(new CustomEvent('cascadia:cart-changed'));
          } catch(err){ console.warn('[cascadia] remove failed', err); removeBtn.disabled = false; }
          return;
        }

        if(minusBtn || plusBtn){
          const stepper = (minusBtn || plusBtn).closest('.cas-qty-stepper');
          const key = stepper.dataset.key;
          const liveCart = window.cascadiaState.peek();
          const item = liveCart && liveCart.items.find(i => i.key === key);
          if(!item) return;
          const newQty = plusBtn ? item.quantity + 1 : item.quantity - 1;

          try {
            if(newQty <= 0){
              await window.cascadiaState.removeFromCart(key);
            } else {
              await window.cascadiaState.updateQuantity(key, newQty);
            }
            document.dispatchEvent(new CustomEvent('cascadia:cart-changed'));
          } catch(err){ console.warn('[cascadia] qty update failed', err); }
        }
      });

      container.addEventListener('keydown', (e) => {
        if(e.target.matches('.cas-qty-input') && e.key === 'Enter'){
          e.preventDefault();
          e.target.blur(); // commits via 'change'
        }
      });

      container.addEventListener('change', async (e) => {
        const input = e.target.closest('.cas-qty-input');
        if(!input) return;
        const key = input.dataset.key;
        const liveCart = window.cascadiaState.peek();
        const item = liveCart && liveCart.items.find(i => i.key === key);
        if(!item) return;

        const newQty = parseInt(input.value, 10);
        if(isNaN(newQty) || newQty < 0){ input.value = item.quantity; return; }
        if(newQty === item.quantity) return;

        input.disabled = true;
        try {
          if(newQty === 0){
            await window.cascadiaState.removeFromCart(key);
          } else {
            await window.cascadiaState.updateQuantity(key, newQty);
          }
          document.dispatchEvent(new CustomEvent('cascadia:cart-changed'));
        } catch(err){
          console.warn('[cascadia] qty input failed', err);
          input.value = item.quantity;
          input.disabled = false;
        }
      });
    }

    // scent names for items added after page load (config only knows what was in the cart then)
    const nameMap = window.cascadiaScentNamesByVariant = window.cascadiaScentNamesByVariant || {};
    const needNames = [...new Set(cart.items
      .filter(i => !nameMap[i.variant_id] && !_scentNameFetched.has(i.handle) &&
        (i.options_with_values || []).some(o => /scent/i.test(o.name)))
      .map(i => i.handle))];
    if(needNames.length){
      needNames.forEach(h => _scentNameFetched.add(h));
      Promise.all(needNames.map(h =>
        fetch(`/products/${h}?view=cart-edit-json`).then(r => r.json()).then(p => {
          (p.variants || []).forEach(v => { if(v.scentName) nameMap[v.id] = v.scentName; });
        }).catch(() => {})
      )).then(() => renderLineItems(window.cascadiaState.peek(), body));
    }

    if(uncachedHandles.length){
      Promise.all(uncachedHandles.map(handle =>
        window.cascadiaState.getProduct(handle).then(product => { _compareAtCache.set(handle, product); })
      )).then(() => {
        renderLineItems(window.cascadiaState.peek(), body);
      });
    }
  }


  // ───────── line item styling ─────────
  function styleLineItems(body){
    const drawerWidth = document.querySelector('#CartDrawer')?.offsetWidth || window.innerWidth;
const isMobile = drawerWidth < 480;
    const thumbSize = isMobile ? '72px' : '96px';
    const cardPadding = isMobile ? '12px 12px 12px' : '16px 16px 8px';

    body.querySelectorAll('.cart__item:not(.cart__item--headers)').forEach(item => {
      item.style.cssText = [
        'display:grid !important',
        `grid-template-columns:${thumbSize} 1fr !important`,
        'grid-template-rows:auto !important',
        'gap:0 12px !important',
        'align-items:start !important',
        'width:100% !important',
        'background:transparent',
        'border:1px solid #e3d9c2',
        'border-radius:14px',
        `padding:${cardPadding}`,
        'margin-bottom:6px',
        'box-sizing:border-box',
        'position:relative'
      ].join(';');
    });

    body.querySelectorAll('.cart__item--headers').forEach(el => {
      el.style.cssText = 'display:none !important';
    });

    body.querySelectorAll('.cart__item--image').forEach(el => {
  el.style.cssText = 'width:' + thumbSize + ';height:' + thumbSize + ';border-radius:10px;overflow:hidden;flex-shrink:0;grid-row:1;grid-column:1;align-self:start;';
  const img = el.querySelector('img, .image-wrap');
  if(img) img.style.cssText = 'width:100% !important;height:100% !important;object-fit:cover;display:block;padding-bottom:0 !important;';
});

    body.querySelectorAll('.cart__item--details').forEach(el => {
      el.style.cssText = [
        'display:flex !important',
        'flex-direction:column !important',
        'min-height:' + (isMobile ? '88px' : '100px'),
        'align-items:flex-start !important',
        'gap:3px !important',
        'min-width:0',
        'grid-row:1',
        'grid-column:2',
        'padding-right:32px'
      ].join(';');
    });

    body.querySelectorAll('.cart__item:not(.cart__item--headers)').forEach(item => {
      const details = item.querySelector('.cart__item--details');
      const price = item.querySelector('.cart__item--price, .cart__item-price-col');
      const qty = item.querySelector('.cart__item--qty');
      if(details && price && price.parentElement !== details){
        details.appendChild(price);
      }
      if(!isMobile && qty && qty.parentElement !== item){
        item.appendChild(qty);
      }
    });

    body.querySelectorAll('.cart__item--price, .cart__item-price-col').forEach(el => {
      el.style.setProperty('display', 'flex', 'important');
      el.style.setProperty('flex-direction', 'row', 'important');
      el.style.setProperty('align-items', 'baseline', 'important');
      el.style.setProperty('gap', '6px', 'important');
      el.style.setProperty('flex-wrap', 'wrap', 'important');
      el.style.setProperty('margin-top', '4px', 'important');
      el.style.setProperty('margin-left', '0', 'important');
      el.style.setProperty('width', 'auto', 'important');
    });

    body.querySelectorAll('.cart__item--price .money, .cart__item-price-col .money').forEach(el => {
      const strikeEl = el.closest('s, .cart__price--strikethrough');
      if(strikeEl){
        el.style.setProperty('font-family', 'Jost, sans-serif', 'important');
        el.style.setProperty('font-size', '13px', 'important');
        el.style.setProperty('font-weight', '400', 'important');
        el.style.setProperty('color', '#a59a8a', 'important');
        strikeEl.style.setProperty('text-decoration', 'line-through', 'important');
        strikeEl.style.setProperty('color', '#a59a8a', 'important');
        return;
      }
      el.style.setProperty('font-family', 'Jost, sans-serif', 'important');
      el.style.setProperty('font-size', '15px', 'important');
      el.style.setProperty('font-weight', '600', 'important');
      el.style.setProperty('color', '#03593A', 'important');
    });

    body.querySelectorAll('.cart__item').forEach(item => {
      const qtyEl = item.querySelector('.cart__item--qty');
      const chip = item.querySelector('.cas-chip, small.cart__discount');
      const details = item.querySelector('.cart__item--details');
      if(!qtyEl || !details) return;

      let row = item.querySelector('.cas-qty-row');
      if(!row){
        row = document.createElement('div');
        row.className = 'cas-qty-row';
        details.appendChild(row);
      }
      if(chip && chip.parentElement !== row) row.insertBefore(chip, row.firstChild);
      if(qtyEl.parentElement !== row) row.appendChild(qtyEl);

      row.style.cssText = isMobile
        ? 'display:flex;flex-direction:column;align-items:flex-start;gap:4px;margin-top:4px;width:100%;'
        : 'display:flex;align-items:center;gap:8px;position:absolute;right:8px;bottom:20px;';

      if(chip){
        chip.style.cssText = [
          'display:inline-flex',
          'align-items:center',
          'background:#f0f7f0',
          'border:1px solid #c8e0c8',
          'border-radius:999px',
          'padding:2px 8px',
          'font-size:10.5px',
          'font-weight:500',
          'color:#03593A',
          'white-space:nowrap'
        ].join(';');
      }

      qtyEl.style.cssText = isMobile
        ? 'margin:0;display:inline-flex;align-items:center;'
        : 'margin:0;';
    });

    // hide qty stepper entirely on any free reward line (soap sample, skincare sample, etc.)
    const currentCart = window.cascadiaState && window.cascadiaState.peek();
    if(currentCart){
      const rewardKeys = [
        currentCart.sampleLine && currentCart.sampleLine.key,
        ...(currentCart.rewardLines ? Object.values(currentCart.rewardLines).map(l => l.key) : [])
      ].filter(Boolean);

      body.querySelectorAll('.cart__item').forEach(item => {
        if(!rewardKeys.includes(item.dataset.key)) return;
        const qtyEl = item.querySelector('.cart__item--qty');
        if(qtyEl) qtyEl.style.setProperty('display', 'none', 'important');
      });
    }

    body.querySelectorAll('.cart__item:not(.cart__item--headers)').forEach(item => {
      if(item.querySelector('.cas-remove-btn')) return;
      const key = item.dataset.key;
      if(!key) return;
      const btn = document.createElement('button');
      btn.className = 'cas-remove-btn';
      btn.setAttribute('aria-label', 'Remove item');
      btn.innerHTML = `<svg viewBox="0 0 20 20" width="16" height="16" fill="currentColor"><path d="M7 2a1 1 0 00-1 1v1H3a1 1 0 000 2h.5l.7 10.2A2 2 0 006.2 18h7.6a2 2 0 002-1.8L16.5 6h.5a1 1 0 000-2h-3V3a1 1 0 00-1-1H7zm1 2V3h4v1H8zm-1.3 2h8.6l-.7 10H6.4l-.7-10z"/></svg>`;
      btn.style.cssText = [
        'position:absolute !important',
        'top:12px','right:8px',
        'display:flex','align-items:center','justify-content:center',
        'width:26px','height:26px',
        'background:none','border:none','cursor:pointer','padding:0',
        'color:#6b5c4a','z-index:2'
      ].join(';');
      btn.addEventListener('click', async () => {
        btn.disabled = true;
        try {
          await window.cascadiaState.removeFromCart(key);
          item.remove();
          document.dispatchEvent(new CustomEvent('cascadia:cart-changed'));
        } catch(e){
          console.warn('[cascadia] remove failed', e);
          btn.disabled = false;
        }
      });
      item.appendChild(btn);
    });

    const products = body.querySelector('[data-products]');
    if(products){
      products.style.setProperty('padding-top', '2px', 'important');
      products.style.setProperty('padding-bottom', '2px', 'important');
    }

    const studio = body.querySelector('#cascadia-studio');
    if(studio) studio.style.setProperty('margin-top', '4px', 'important');
  }

  // ───────── quantity stepper styling ─────────
  function styleQuantitySteppers(body){
    body.querySelectorAll('.js-qty__wrapper').forEach(wrapper => {
      wrapper.style.setProperty('display', 'inline-flex', 'important');
      wrapper.style.setProperty('align-items', 'center', 'important');
      wrapper.style.setProperty('border', '1px solid #3d2314', 'important');
      wrapper.style.setProperty('border-radius', '999px', 'important');
      wrapper.style.setProperty('overflow', 'hidden', 'important');
      wrapper.style.setProperty('background', 'none', 'important');
      wrapper.style.setProperty('padding', '0', 'important');
      wrapper.style.setProperty('gap', '0', 'important');
      wrapper.style.setProperty('width', 'fit-content', 'important');
      wrapper.style.setProperty('height', 'auto', 'important');
    });

    body.querySelectorAll('.js-qty__adjust').forEach(btn => {
      btn.style.setProperty('background', 'none', 'important');
      btn.style.setProperty('border', 'none', 'important');
      btn.style.setProperty('outline', 'none', 'important');
      btn.style.setProperty('box-shadow', 'none', 'important');
      btn.style.setProperty('border-radius', '0', 'important');
      btn.style.setProperty('padding', '5px 0px', 'important');
      btn.style.setProperty('cursor', 'pointer', 'important');
      btn.style.setProperty('display', 'flex', 'important');
      btn.style.setProperty('align-items', 'center', 'important');
      btn.style.setProperty('justify-content', 'center', 'important');
      btn.style.setProperty('width', '32px', 'important');
      btn.style.setProperty('height', '28px', 'important');
      btn.style.setProperty('min-width', '32px', 'important');
      btn.style.setProperty('min-height', '0', 'important');
      btn.style.setProperty('max-width', 'none', 'important');
      btn.style.setProperty('max-height', 'none', 'important');
      btn.style.setProperty('color', '#3d2314', 'important');
      btn.style.setProperty('font-size', '18px', 'important');
      btn.style.setProperty('line-height', '1', 'important');
      btn.style.setProperty('overflow', 'visible', 'important');
      btn.style.setProperty('flex-shrink', '0', 'important');
      const svg = btn.querySelector('svg');
      if(svg) svg.style.setProperty('display', 'none', 'important');
    });

    body.querySelectorAll('.js-qty__num').forEach(input => {
      input.style.setProperty('border-top', 'none', 'important');
      input.style.setProperty('border-bottom', 'none', 'important');
      input.style.setProperty('border-left', '1px solid #3d2314', 'important');
      input.style.setProperty('border-right', '1px solid #3d2314', 'important');
      input.style.setProperty('background', 'none', 'important');
      input.style.setProperty('width', '28px', 'important');
      input.style.setProperty('height', '28px', 'important');
      input.style.setProperty('min-height', '0', 'important');
      input.style.setProperty('text-align', 'center', 'important');
      input.style.setProperty('font-family', 'Jost, sans-serif', 'important');
      input.style.setProperty('font-size', '12px', 'important');
      input.style.setProperty('font-weight', '500', 'important');
      input.style.setProperty('color', '#3d2314', 'important');
      input.style.setProperty('padding', '0', 'important');
      input.style.setProperty('line-height', '28px', 'important');
      input.style.setProperty('display', 'flex', 'important');
      input.style.setProperty('align-items', 'center', 'important');
      input.style.setProperty('justify-content', 'center', 'important');
    });

    body.querySelectorAll('.js-qty__adjust .icon__fallback-text').forEach(span => {
      span.style.setProperty('position', 'static', 'important');
      span.style.setProperty('width', 'auto', 'important');
      span.style.setProperty('height', 'auto', 'important');
      span.style.setProperty('overflow', 'visible', 'important');
      span.style.setProperty('clip', 'auto', 'important');
      span.style.setProperty('display', 'block', 'important');
      span.style.setProperty('font-size', '18px', 'important');
      span.style.setProperty('color', '#3d2314', 'important');
      span.style.setProperty('line-height', '1', 'important');
      span.style.setProperty('text-align', 'center', 'important');
    });
  }

  // ───────── show line total (unit price × qty), not just unit price ─────────
  function updateLineItemTotals(cart, body){
    if(!cart || !cart.items) return;

    cart.items.forEach(item => {
      const lineEl = body.querySelector(`[data-key="${item.key}"]`);
      if(!lineEl) return;

      const priceEl = lineEl.querySelector('.cart__item--price .money:not(s .money), .cart__item-price-col .money:not(s .money)');
      if(!priceEl) return;
      if(priceEl.closest('.cas-compare-price')) return; // applyCompareAtPrices owns this case

      const lineTotal = item.line_price != null ? item.line_price : (item.price * item.quantity);
      priceEl.textContent = moneyFormat(lineTotal);
    });
  }

  // ───────── compare-at price display ─────────
  const _compareAtCache = new Map(); // handle -> product JSON, persists across renders

  async function applyCompareAtPrices(body){
    let cart;
    try { cart = (await window.cascadiaState.getState()).raw; } catch(e){ return; }

    const handles = [...new Set(cart.items.map(i => i.handle))];
    await Promise.all(handles.map(async handle => {
      if(_compareAtCache.has(handle)) return;
      const product = await window.cascadiaState.getProduct(handle);
      _compareAtCache.set(handle, product);
    }));

    for(const item of cart.items){
      try {
        const product = _compareAtCache.get(item.handle);
        if(!product) continue;
        const variant = product.variants.find(v => v.id === item.variant_id);
        if(!variant || !variant.compare_at_price || variant.compare_at_price <= item.price) continue;

        const lineEl = body.querySelector(`[data-key="${item.key}"]`);
        if(!lineEl) continue;

        const lineTotal = item.line_price != null ? item.line_price : (item.price * item.quantity);
        const compareTotal = variant.compare_at_price * item.quantity;
        const compareFormatted = '$' + (compareTotal / 100).toFixed(2);
        const saleFormatted = '$' + (lineTotal / 100).toFixed(2);

        const existingWrapper = lineEl.querySelector('.cas-compare-price');
        if(existingWrapper){
          const sEl = existingWrapper.querySelector('s');
          const saleEl = existingWrapper.querySelector('span:not(s)');
          if(sEl) sEl.textContent = compareFormatted;
          if(saleEl) saleEl.textContent = saleFormatted;
          continue;
        }

        const priceEl = lineEl.querySelector('.cart__item--price .money:not(s .money), .cart__item-price-col .money:not(s .money)');
        if(!priceEl) continue;

        const wrapper = document.createElement('span');
        wrapper.className = 'cas-compare-price';
        wrapper.style.cssText = 'display:inline-flex;align-items:baseline;gap:6px;';
        wrapper.innerHTML = `
          <s style="font-size:13px;font-weight:400;color:#a59a8a;text-decoration-color:#a59a8a;">${compareFormatted}</s>
          <span style="font-size:15px;font-weight:600;color:#03593A;">${saleFormatted}</span>
        `;
        priceEl.replaceWith(wrapper);
      } catch(e){ /* skip silently */ }
    }
  }

  // ───────── drawer shell styling ─────────
  function styleDrawerShell(){
    const isDrawer = !document.querySelector('#CartPageForm');
    if(!isDrawer) return;

    // Motion can inject its own <style data-shopify> tag that sets
    // .drawer__contents padding-top for its native (now-hidden) title bar.
    // A static CSS rule can lose that race depending on injection order,
    // so set this directly via JS instead — same defensive pattern already
    // used elsewhere in this file — since an inline style always wins
    // over any stylesheet rule, !important or not.
    if(window.innerWidth <= 589){
      const drawerEl = document.querySelector('#CartDrawer');
      const contentsEl = document.querySelector('#CartDrawer .drawer__contents');
      const innerEl = document.querySelector('#CartDrawer .drawer__inner');
      [drawerEl, contentsEl, innerEl].forEach(el => {
        if(!el) return;
        el.style.setProperty('padding-top', '0', 'important');
        el.style.setProperty('margin-top', '0', 'important');
      });
    }

    const drawerEl = document.querySelector('#CartDrawer');

    // ── inject our header if not already there ──
    const inner = document.querySelector('.drawer__inner');
    if(inner && !inner.querySelector('#cas-drawer-header')){
      const h = document.createElement('div');
      h.id = 'cas-drawer-header';
      h.style.cssText = [
        'display:flex',
        'align-items:center',
        'justify-content:space-between',
        'padding:14px 20px 12px',
        'background:#fff',
        'border-bottom:0.5px solid #e8e5e0',
        'margin-bottom:8px',
        'position:sticky',
        'top:0',
        'z-index:10',
        'box-sizing:border-box',
        'width:100%'
      ].join(';');
      h.innerHTML = `
        <span style="font-family:'Cormorant Garamond',Georgia,serif;font-style:italic;font-size:18px;font-weight:400;color:#3d2314;">Your Cart 🌱</span>
        <button id="cas-drawer-close" aria-label="Close cart" style="width:28px;height:28px;border-radius:50%;background:#f0ece7;border:none;cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0;flex-shrink:0;">
          <svg width="11" height="11" viewBox="0 0 64 64" fill="none" stroke="#3d2314" stroke-width="6" stroke-linecap="round"><path d="m19 17.61 27.12 27.13m0-27.12L19 44.74"/></svg>
        </button>`;
      h.querySelector('#cas-drawer-close').addEventListener('click', (e) => {
  e.preventDefault();
  e.stopPropagation();
  const nativeClose = document.querySelector('#CartDrawer .js-drawer-close');
  if(nativeClose) nativeClose.click();
});
      inner.prepend(h);
    }

    // ── tighten scrollable ──
    const scrollable = document.querySelector('.drawer__scrollable');
    if(scrollable){
      scrollable.style.setProperty('padding-top', '0', 'important');
      scrollable.style.setProperty('padding-left', '20px', 'important');
      scrollable.style.setProperty('padding-right', '20px', 'important');
      scrollable.style.setProperty('overflow-y', 'auto', 'important');
      scrollable.style.setProperty('flex', '1 1 auto', 'important');
    }

    // ── checkout button ──
    const checkoutBtn = document.querySelector('#CartDrawer button[name="checkout"], #CartDrawer .cart__checkout-button, #CartDrawer a[href="/checkout"]');
    if(checkoutBtn && !checkoutBtn.dataset.casStyled){
      checkoutBtn.dataset.casStyled = '1';
      checkoutBtn.style.setProperty('background', '#1a3d2b', 'important');
      checkoutBtn.style.setProperty('color', '#fff', 'important');
      checkoutBtn.style.setProperty('border', 'none', 'important');
      checkoutBtn.style.setProperty('border-radius', '14px', 'important');
      checkoutBtn.style.setProperty('width', '100%', 'important');
      checkoutBtn.style.setProperty('padding', '14px 20px', 'important');
      checkoutBtn.style.setProperty('font-size', '15px', 'important');
      checkoutBtn.style.setProperty('font-weight', '600', 'important');
      checkoutBtn.style.setProperty('letter-spacing', '0.02em', 'important');
      checkoutBtn.style.setProperty('cursor', 'pointer', 'important');
      checkoutBtn.style.setProperty('display', 'flex', 'important');
      checkoutBtn.style.setProperty('align-items', 'center', 'important');
      checkoutBtn.style.setProperty('justify-content', 'center', 'important');
      checkoutBtn.style.setProperty('gap', '8px', 'important');
      checkoutBtn.innerHTML = '🔒 <span style="font-family:Jost,sans-serif;font-size:15px;font-weight:600;letter-spacing:0.02em;">Secure Checkout</span>';
    }
  }

  // ───────── empty cart state ─────────
  function renderEmptyCart(body, emptyLabel, isEmpty){
  const isDrawer = !document.querySelector('#CartPageForm');
  if(!isDrawer) return;

  const cartDrawer = document.querySelector('#CartDrawer');
  if(!cartDrawer) return;

  const inner = document.querySelector('#CartDrawer .drawer__inner');

  // cart has items — remove empty state and restore normal drawer
  if(!isEmpty){
    const existing = document.querySelector('#cas-empty-cart');
    if(existing) existing.remove();
    return;
  }

  if(document.querySelector('#cas-empty-cart')) return;
  if(!inner) return;

    const sorted = [...(CFG.tiers || [])].sort((a,b) => a.threshold - b.threshold);
    const ladderHtml = sorted.length ? `
      <div style="padding:12px 20px 10px;border-bottom:0.5px solid #e8e5e0;">
        <p style="font-family:'Cormorant Garamond',Georgia,serif;font-style:italic;font-size:17px;color:#3d2314;margin:0 0 10px;line-height:1.3;font-weight:500;">${emptyLabel || `Gifts unlock from $${sorted[0].threshold}`}</p>
        <div style="display:flex;gap:4px;height:4px;border-radius:999px;overflow:hidden;margin-bottom:4px;">
          ${sorted.map(() => `<div style="flex:1;background:#e8e5e0;border-radius:999px;"></div>`).join('')}
        </div>
        <div style="display:flex;">
          ${sorted.map(t => `
            <div style="flex:1;text-align:center;">
              <span style="font-size:11px;font-weight:400;color:#a59a8a;white-space:nowrap;">$${t.threshold} · ${shortLabel(t.label)}</span>
            </div>`).join('')}
        </div>
      </div>` : '';

    const emptyStationsHtml = sorted.length
      ? `<div style="padding:4px 20px 6px;border-bottom:0.5px solid #e8e5e0;">${ladderStationsHtml(
          sorted.map(t => ({ tier: t, filled: false, active: false, fillPct: 0 })),
          emptyLabel || `Gifts unlock from <b>$${sorted[0].threshold}</b>`
        )}</div>`
      : '';

    const el = document.createElement('div');
    el.id = 'cas-empty-cart';
    el.style.cssText = 'display:flex;flex-direction:column;flex:1;background:#fff;overflow-y:auto;';
    el.innerHTML = `
      ${emptyStationsHtml}
      <div style="flex:1;display:flex;flex-direction:column;align-items:center;justify-content:flex-start;padding:32px 28px 24px;text-align:center;">
        <img src="/cdn/shop/files/CascadiaSkincareLogosymbol.png"
          style="width:52px;height:52px;object-fit:contain;margin:0 auto 20px;opacity:0.80;" />
        <p style="font-size:9px;letter-spacing:.22em;text-transform:uppercase;color:#a59a8a;margin:0 0 10px;font-family:'Jost',sans-serif;">nothing here yet</p>
        <p style="font-family:'Cormorant Garamond',Georgia,serif;font-size:28px;font-style:italic;color:#3d2314;margin:0 0 12px;line-height:1.15;">Something beautiful<br>is waiting.</p>
        <p style="font-size:12px;color:#8a7e6e;margin:0;line-height:1.8;font-family:'Jost',sans-serif;">Hand-made in Vancouver.<br>Ingredients you can trust.</p>
      </div>
      <div id="cas-empty-studio-anchor" style="padding:0 0 16px;"></div>`;

    inner.appendChild(el);

    // move studio into anchor once it renders
    setTimeout(() => {
      const studioEl = document.querySelector('#cascadia-studio');
      const anchor = el.querySelector('#cas-empty-studio-anchor');
      if(studioEl && anchor) anchor.appendChild(studioEl);
    }, 200);
  }

  // ───────── empty cart page state ─────────
function renderEmptyCartPage(){
  // run on cart page only — check URL since CartPageForm may not exist when empty
  const isCartPage = window.location.pathname === '/cart';
  if(!isCartPage) return;

  const container = document.querySelector('.page-width--narrow.is-empty');
  if(!container) return;

  // remove stale injection from previous render
  const existing = document.querySelector('#cas-page-empty-cart');
  if(existing) existing.remove();

  // hide native empty elements
  const header = container.querySelector('.section-header');
  const emptyText = container.querySelector('.cart__empty-text');
  if(header) header.style.setProperty('display', 'none', 'important');
  if(emptyText) emptyText.style.setProperty('display', 'none', 'important');

  const sorted = [...(CFG.tiers || [])].sort((a,b) => a.threshold - b.threshold);

  const ladderHtml = sorted.length ? `
    <div style="padding:16px 0 14px;margin-bottom:32px;">
      <p style="font-family:'Cormorant Garamond',Georgia,serif;font-style:italic;font-size:20px;color:#3d2314;margin:0 0 12px;line-height:1.3;">Gifts unlock from $${sorted[0].threshold}</p>
      <div style="display:flex;gap:4px;height:4px;border-radius:999px;overflow:hidden;margin-bottom:6px;">
        ${sorted.map(() => `<div style="flex:1;background:#e8e5e0;border-radius:999px;"></div>`).join('')}
      </div>
      <div style="display:flex;">
        ${sorted.map(t => `
          <div style="flex:1;text-align:center;">
            <span style="font-size:11px;color:#a59a8a;font-family:'Jost',sans-serif;white-space:nowrap;">$${t.threshold} · ${shortLabel(t.label)}</span>
          </div>`).join('')}
      </div>
    </div>` : '';

  const el = document.createElement('div');
  el.id = 'cas-page-empty-cart';
  el.style.cssText = 'max-width:100%;padding:0 24px 60px;';
  el.innerHTML = `
    ${ladderHtml}
    <div style="text-align:center;margin-bottom:40px;">
      <img src="/cdn/shop/files/CascadiaSkincareLogosymbol.png"
        style="width:52px;height:52px;object-fit:contain;margin:0 auto 20px;opacity:0.8;display:block;" />
      <p style="font-size:8px;letter-spacing:.22em;text-transform:uppercase;color:#a59a8a;margin:0 0 10px;font-family:'Jost',sans-serif;">nothing here yet</p>
      <p style="font-family:'Cormorant Garamond',Georgia,serif;font-size:42px;font-style:italic;color:#3d2314;margin:0 0 14px;line-height:1.1;">Something beautiful<br>is waiting.</p>
      <p style="font-size:14px;color:#8a7e6e;margin:0 0 28px;line-height:1.8;font-family:'Jost',sans-serif;">Hand-made in Vancouver.<br>Ingredients you can trust,<br>results you can feel.</p>
      <a href="/collections/all" style="display:inline-block;background:#3d2314;color:#faf8f5;border-radius:10px;padding:13px 32px;font-family:'Jost',sans-serif;font-size:13px;font-weight:500;letter-spacing:.04em;text-decoration:none;">Shop the collection</a>
    </div>
    <div id="cas-page-studio-anchor"></div>`;

  container.appendChild(el);

  // add page title above
const titleEl = document.createElement('div');
titleEl.style.cssText = 'max-width:100%;margin-bottom:24px;';
titleEl.innerHTML = "<p style=\"font-size:9px;letter-spacing:.16em;text-transform:uppercase;color:#a59a8a;margin:0 0 8px;font-family:'Jost',sans-serif;text-align:center;\">Your cart</p><div style=\"height:0.5px;background:#e8e5e0;\"></div>";
el.insertBefore(titleEl, el.firstChild);

  setTimeout(() => {
    const studio = document.querySelector('#cascadia-studio');
    const anchor = el.querySelector('#cas-page-studio-anchor');
    if(studio && anchor){
      studio.style.setProperty('max-width', '100%', 'important');
      studio.style.setProperty('margin', '0', 'important');
      anchor.appendChild(studio);
    }
  }, 200);
}

  // ───────── watch for Motion DOM swaps ─────────
  // IMPORTANT: only watch [data-products] / .cart__items, never drawer__inner
  // watching inner causes our own DOM injections to re-trigger renders
  function observeCartChanges(){
    const body = $body();
    if(!body) return;
    // do not fall back to body — if no products container exists, don't observe
    const target = body.querySelector('[data-products], .cart__items');
    if(!target) return;

    const obs = new MutationObserver(() => {
      // skip if we're mid-render or about to render, to prevent redundant restyle passes
      if(_rendering || scheduled) return;
      styleLineItems(body);
      styleQuantitySteppers(body);
    });
    obs.observe(target, { childList: true, subtree: true });
  }

  // ───────── styles ─────────
  if(!$('#cascadia-cart-css')){
    const st = document.createElement('style');
    st.id = 'cascadia-cart-css';
    st.textContent = `

      /* ── hide native cart contents until our own first render completes ── */
      #CartDrawer:not([data-cas-ready]) .drawer__scrollable,
      #CartDrawer:not([data-cas-ready]) .drawer__footer {
        visibility: hidden !important;
      }

      /* ── widen cart drawer ── */
      #CartDrawer {
        width: min(520px, 100vw) !important;
        max-width: 100vw !important;
      }

      /* ── hide Motion's native empty state — visibility not display so transitions still fire ── */
.drawer__cart-empty {
  visibility: hidden !important;
  pointer-events: none !important;
  position: absolute !important;
  z-index: -1 !important;
}

/* ── when our empty state exists, give inner a height ── */
#CartDrawer .drawer__inner:has(#cas-empty-cart) {
  display: flex !important;
  flex-direction: column !important;
  height: 100% !important;
}

/* ── hide scrollable and footer when our empty state is present ── */
#CartDrawer .drawer__inner:has(#cas-empty-cart) .drawer__scrollable,
#CartDrawer .drawer__inner:has(#cas-empty-cart) .drawer__footer {
  display: none !important;
}

/* ── our empty state fills the remaining height ── */
#cas-empty-cart {
  display: flex !important;
  flex-direction: column !important;
  flex: 1 !important;
  min-height: 0 !important;
}

/* ── no gap between header and empty state ── */
#CartDrawer #cas-drawer-header {
  margin-bottom: 0 !important;
  flex-shrink: 0 !important;
}

      /* ── suppress native drawer header ── */
      #CartDrawer .drawer__fixed-header,
      #CartDrawer .drawer__header {
        min-height: 0 !important;
        height: 0 !important;
        overflow: hidden !important;
        padding: 0 !important;
        margin: 0 !important;
      }
      #CartDrawer .drawer__title,
      #CartDrawer .drawer__close {
        display: none !important;
      }
      @media only screen and (min-width: 590px) {
        #CartDrawer .drawer__fixed-header,
        #CartDrawer .drawer__header {
          min-height: 0 !important;
          height: 0 !important;
        }
      }

      /* ── fix scrollable padding ── */
      #CartDrawer .drawer__scrollable {
        padding-top: 0 !important;
      }
      @media only screen and (min-width: 590px) {
        #CartDrawer .drawer__scrollable {
          padding-top: 0 !important;
          padding-left: 20px !important;
          padding-right: 20px !important;
        }
      }

      /* ── smooth cart update transition — masks Motion's native rebuild flash ── */
      .drawer__inner, #CartPageForm {
        transition: opacity 0.15s ease !important;
      }

      /* ── CSS variables ── */
      #CartDrawer, #CartPageForm { --colorSalePrice: #03593A; }

      @media screen and (max-width:589px) {
        .cas-line-actions { flex-direction:column !important; align-items:center !important; gap:6px !important; }
        .cas-line-actions .cas-edit-btn { width:30px !important; height:30px !important; padding:0 !important; border-radius:50% !important; gap:0 !important; justify-content:center; }
        .cas-line-actions .cas-edit-label { display:none !important; }
        .cas-qty-input { font-size:16px !important; } /* under 16px, iPhones zoom the page on tap */
      }

      /* ── typeable qty ── */
      .cas-qty-input { font-size:13px; font-weight:500; -moz-appearance:textfield; appearance:textfield; }
      .cas-qty-input::-webkit-outer-spin-button,
      .cas-qty-input::-webkit-inner-spin-button { -webkit-appearance:none; margin:0; }
      .cas-qty-input:focus { outline:none; background:#f0ece7 !important; }
      .cas-qty-input:disabled { opacity:.5; }

      /* ── savings chip ── */
      .cas-chip { color:#03593A !important; font-weight:500 !important; font-size:11px !important; background:none !important; text-decoration:none !important; }
      .cas-bundle-sub:first-child { border-top: none !important; }
      .cas-upsell-strip::-webkit-scrollbar { display: none; }

      /* ── "In your cart" box ── */
      .cas-cart-box { border:1.5px solid #1e3a20; border-radius:16px; overflow:hidden; background:#fff; margin-bottom:6px; }
      .cas-cart-box__head { display:flex; align-items:center; justify-content:space-between; padding:10px 14px; background:#1e3a20; color:#fff; font-family:'Jost',sans-serif; }
      .cas-cart-box__title { display:flex; align-items:center; gap:6px; font-size:13px; font-weight:600; }
      .cas-cart-box__count { font-size:12.5px; font-weight:500; }
      /* items become rows inside the box instead of separate cards */
      .cas-cart-box .cas-line-item,
      .cas-cart-box .cas-bundle-card { border:none !important; border-radius:0 !important; margin:0 !important; }
      .cas-cart-box > .cas-line-item:not(:nth-child(2)),
      .cas-cart-box > .cas-bundle-card:not(:nth-child(2)) { border-top:1px solid #ece6db !important; }

      /* ── trust line ── */
      #cascadia-trust { display:flex; gap:6px; justify-content:center; font-size:11px; color:#6b5c4a; margin:0 0 10px; }

      /* ── scent dots ── */
      .cas-dot            { width:26px; height:26px; border-radius:50%; border:0; cursor:pointer; padding:0; background:var(--c); box-shadow:0 0 0 1px #e8e5e0, inset 0 0 0 2px #fff; transition:.15s; position:relative; }
      .cas-dot:hover      { transform:scale(1.1); }
      .cas-dot.sel        { box-shadow:0 0 0 2px #03593A, inset 0 0 0 2px #fff; transform:scale(1.1); }
      .cas-dot.sel::after { content:'✓'; position:absolute; inset:0; display:grid; place-items:center; color:#fff; font-size:11px; text-shadow:0 1px 2px rgba(0,0,0,.45); }
      .cas-dot:focus-visible { outline:2px solid #03593A; outline-offset:2px; }

      /* ── line item text styles ── */
      .cart__product-name         { font-family:'Jost',sans-serif; font-size:13px; font-weight:500; color:#3d2314; text-decoration:none; line-height:1.3; }
      .cart__product-name:hover   { color:#1e3a20; }
      .cart__item--variants       { font-family:'Jost',sans-serif; font-size:11.5px; color:#6b5c4a; line-height:1.3; }
      .cart__item .money          { font-family:'Jost',sans-serif; font-size:13px; font-weight:500; color:#3d2314; }
      .cart__item s .money        { font-size:13px !important; font-weight:400 !important; color:#a59a8a !important; text-decoration:line-through !important; }

      /* ── line item discount chip ── */
      small.cart__discount { font-family:'Jost',sans-serif; font-size:10.5px; font-weight:500; color:#03593A; background:#f0f7f0; border:1px solid #c8e0c8; border-radius:999px; padding:2px 8px; display:inline-block; margin-top:2px; white-space:nowrap; }

      /* ── remove button ── */
      .cart__remove, .cart__item .btn--remove           { display:flex; align-items:center; justify-content:center; width:28px; height:28px; border-radius:50%; background:none; border:none; cursor:pointer; color:#6b5c4a; transition:.15s; padding:0; }
      .cart__remove:hover, .cart__item .btn--remove:hover { background:#f5f0eb; color:#3d2314; }
      .cart__remove svg, .cart__item .btn--remove svg   { width:14px; height:14px; fill:currentColor; }

      /* ── hide Motion column headers ── */
      .cart__item--headers { display:none !important; }

      /* ── qty stepper ── */
      .cart__item--qty { margin-top:4px; }
      .js-qty__adjust:focus,
      .js-qty__adjust:focus-visible,
      .js-qty__adjust:active { outline:none !important; box-shadow:none !important; }

      /* ── footer padding ── */
#CartDrawer .drawer__footer {
  padding: 0 20px 14px !important;
  flex-shrink: 0 !important;
}

#CartDrawer .additional-checkout-buttons {
  display: none !important;
}

/* ── flat footer ── */
#CartDrawer .drawer__footer {
  padding: 0 20px 14px !important;
  background: #fff !important;
  border-top: 0.5px solid #e8e5e0 !important;
  flex-shrink: 0 !important;
  margin-top: 8px !important;
}
#CartDrawer .drawer__footer > *:not(#cas-footer-card) {
  display: none !important;
}

@media only screen and (max-width: 589px) {
        #CartDrawer {
          position: fixed !important;
          top: auto !important;
          bottom: 0 !important;
          left: 0 !important;
          right: 0 !important;
          width: 100% !important;
          max-width: 100% !important;
          height: 92vh !important;
          max-height: 92vh !important;
          border-radius: 20px 20px 0 0 !important;
          transform: translateY(100%) !important;
          transition: transform 0.35s cubic-bezier(0.32, 0.72, 0, 1) !important;
          display: flex !important;
          flex-direction: column !important;
        }
        #CartDrawer.drawer--is-open {
          transform: translateY(0) !important;
        }
        #CartDrawer .drawer__contents,
        #CartDrawer .drawer__inner {
          padding-top: 0 !important;
          margin-top: 0 !important;
        }
          
        #CartDrawer .drawer__scrollable {
          flex: 1 1 auto !important;
          min-height: 0 !important;
          overflow-y: auto !important;
        }
        #CartDrawer .drawer__footer {
          flex-shrink: 0 !important;
        }
        #CartDrawer #cas-drawer-header {
          padding: 10px 20px 8px !important;
        }
      }
      @media (prefers-reduced-motion: reduce) {
        #CartDrawer {
          transition: none !important;
        }
      }

/* ── cart page footer parity ── */
#CartPageForm .cart__footer {
  margin-left: auto !important;
  padding: 20px 0 0 !important;
}
#CartPageForm .cart__footer .grid {
  display: block !important;
}
#CartPageForm .cart__footer .grid__item {
  width: 100% !important;
  text-align: left !important;
  float: none !important;
  padding: 0 !important;
  margin: 0 !important;
}
#CartPageForm .cart__subtotal-wrapper,
#CartPageForm .cart__item-sub {
  display: flex !important;
  justify-content: space-between !important;
  align-items: baseline !important;
  padding: 10px 0 !important;
  border-top: 0.5px solid #e8e5e0 !important;
  font-family: 'Jost', sans-serif !important;
}
#CartPageForm .cart__subtotal {
  font-family: 'Cormorant Garamond', Georgia, serif !important;
  font-style: italic !important;
  font-size: 17px !important;
  font-weight: 400 !important;
  color: #3d2314 !important;
}
#CartPageForm [data-subtotal] .money {
  font-size: 17px !important;
  font-weight: 600 !important;
  color: #3d2314 !important;
}
#CartPageForm .cart__checkout-wrapper {
  margin-top: 8px !important;
}
#CartPageForm button[name="checkout"] {
  width: 100% !important;
  background: #1a3d2b !important;
  color: #fff !important;
  border: none !important;
  border-radius: 999px !important;
  padding: 13px 18px !important;
  font-family: 'Jost', sans-serif !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  letter-spacing: 0.03em !important;
  cursor: pointer !important;
  box-shadow: 0 2px 16px rgba(26,61,43,0.3), inset 0 1px 0 rgba(200,162,78,0.25), inset 0 -1px 0 rgba(0,0,0,0.15) !important;
}
/* hide native wallet buttons on cart page */
#CartPageForm .additional-checkout-buttons {
  display: none !important;
}
/* hide ajaxcart note */
#CartPageForm .ajaxcart__note {
  display: none !important;
}

/* ── cart page title ── */
.template-cart #MainContent .section-header__title {
  font-family: 'Cormorant Garamond', Georgia, serif !important;
  font-style: italic !important;
  font-weight: 400 !important;
  font-size: 40px !important;
  color: #3d2314 !important;
}

/* ── cart page continue shopping link ── */
.template-cart #MainContent .section-header .rte a {
  display: inline-block !important;
  background: #3d2314 !important;
  color: #faf8f5 !important;
  border-radius: 999px !important;
  padding: 8px 22px !important;
  font-family: 'Jost', sans-serif !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  letter-spacing: 0.04em !important;
  text-decoration: none !important;
}

/* ── cart page title text ── */
.template-cart #MainContent .section-header__title {
  font-size: 0 !important;
}
.template-cart #MainContent .section-header__title::before {
  content: 'Your Cart';
  font-size: 40px;
  font-family: 'Cormorant Garamond', Georgia, serif;
  font-style: italic;
  font-weight: 400;
  color: #3d2314;
}

/* ── tighten space above ladder on cart page ── */
.template-cart #CartPageForm #cascadia-ladder {
  margin-top: -16px !important;
}
    `;
    document.head.appendChild(st);
  }

  // ───────── event listeners ─────────
  let scheduled = false;
  const MIN_DIM_MS = 1000;

  function scheduleRender(){
    if(scheduled) return;
    if(_rendering) return;
    scheduled = true;

    const body = $body();
    if(body) body.style.setProperty('opacity', '0.4', 'important');
    const dimStartedAt = Date.now();

    setTimeout(() => {
      scheduled = false;
      const undim = () => {
        const elapsed = Date.now() - dimStartedAt;
        const remaining = Math.max(0, MIN_DIM_MS - elapsed);
        setTimeout(() => {
          const b = $body();
          if(b){
            b.style.removeProperty('opacity');
            clearTimeout(b._casDimSafety);
          }
        }, remaining);
      };
      render().then(undim).catch(e => {
        console.warn('[cascadia] render error', e);
        undim();
      });
    }, 80);
  }

  // ───────── dim immediately on any qty interaction, before Motion's rebuild paints ─────────
  function dimNow(){
    const body = $body();
    if(!body) return;
    body.style.setProperty('opacity', '0.4', 'important');
    clearTimeout(body._casDimSafety);
    body._casDimSafety = setTimeout(() => {
      body.style.removeProperty('opacity');
    }, 5000);
  }
  document.addEventListener('click', function(e){
    if(e.target.closest('.js-qty__adjust, .cas-remove-btn')) dimNow();
  }, true);
  document.addEventListener('change', function(e){
    if(e.target.matches('.js-qty__num')) dimNow();
  });

  document.addEventListener('cascadia:cart-changed', scheduleRender);
  document.addEventListener('ajaxProduct:added',     scheduleRender);
  document.addEventListener('cart:updated',          scheduleRender);
  document.addEventListener('cart:refresh',          scheduleRender);
  document.addEventListener('click', e => {
    if(e.target.closest('[data-cart-drawer-toggle], a[href="/cart"], .cart-icon, [class*="cart-icon"], [class*="header__icon--cart"]')){
      scheduleRender();
    }
  });

  document.addEventListener('click', function(e){
    if(e.target.closest(SEL.checkoutBtn)){
      window.cascadiaTrack('checkout_button_clicked');
    }
  }, true);

  document.addEventListener('click', function(e){
    if(e.target.closest('#cas-drawer-close, .js-drawer-close')){
      window.cascadiaTrack('cart_drawer_closed_no_checkout');
    }
  }, true);

  document.addEventListener('cart:open', function(){
    window.cascadiaTrack('cart_drawer_opened');
  });

// ───────── own the entire add-to-cart pipeline — bypass Motion's AjaxProduct + buildCart entirely ─────────
  function updateCartBadge(cart){
    var count = cart.itemCount;
    document.querySelectorAll('.cart-link__bubble-num').forEach(el => { el.innerText = count; });
    document.querySelectorAll('.cart-link__bubble').forEach(el => {
      el.classList.toggle('cart-link__bubble--visible', count > 0);
    });
  }

  document.addEventListener('submit', function(evt){
    var form = evt.target;
    if(!form.matches('.product-single__form, form[action*="/cart/add"]')) return;

    evt.preventDefault();
    evt.stopPropagation(); // capture phase — stops Motion's own bubble-phase listener on this same form from ever firing

    var addToCartBtn = form.querySelector('[data-add-to-cart]');
    if(addToCartBtn) addToCartBtn.classList.add('btn--loading');

    var formData = new FormData(form);
    var variantId = formData.get('id');
    var quantity = parseInt(formData.get('quantity'), 10) || 1;

    var properties = {};
    for(const [key, value] of formData.entries()){
      var match = key.match(/^properties\[(.+)\]$/);
      if(match) properties[match[1]] = value;
    }

    window.cascadiaState.addToCart(variantId, quantity, properties)
      .then(function(){
        if(addToCartBtn) addToCartBtn.classList.remove('btn--loading');

        // preserve Motion's existing cart-page reload behavior
        if(document.body.classList.contains('template-cart')){
          window.scrollTo(0, 0);
          location.reload();
          return;
        }

        document.dispatchEvent(new CustomEvent('cart:open'));
      })
      .catch(function(err){
        if(addToCartBtn) addToCartBtn.classList.remove('btn--loading');
        console.warn('[cascadia] add to cart failed', err);
        alert('Something went wrong adding that to your cart — please try again.');
      });
  }, true);

  render();
  console.log('[cascadia] cart system live · tiers', (CFG.tiers||[]).length, '· soap @ $' + soapThreshold());

})();